import { render, staticRenderFns } from "./failedUploadDocsModal.vue?vue&type=template&id=158a25d0&scoped=true"
import script from "./failedUploadDocsModal.vue?vue&type=script&lang=js"
export * from "./failedUploadDocsModal.vue?vue&type=script&lang=js"
import style0 from "./failedUploadDocsModal.vue?vue&type=style&index=0&id=158a25d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a25d0",
  null
  
)

export default component.exports